import { render, staticRenderFns } from "./_AssuntoFormAdicionar.vue?vue&type=template&id=29f1a98e&scoped=true"
import script from "./_AssuntoFormAdicionar.vue?vue&type=script&lang=ts"
export * from "./_AssuntoFormAdicionar.vue?vue&type=script&lang=ts"
import style0 from "./_AssuntoFormAdicionar.vue?vue&type=style&index=0&id=29f1a98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1a98e",
  null
  
)

export default component.exports